import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Guid } from 'guid-typescript';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/core/auth/auth.service';
import { IAuditTrail } from '../../model/audit-trail-model';
import { AuditTrailService } from '../../services/audit-trail.service';
import { ApiResult } from '@app/shared/model/apiresult';

@Component({
    selector: 'app-audit-trail',
    templateUrl: './audit-trail.component.html'
})
export class AuditTrailComponent implements OnInit, AfterViewInit {
    studentID: Guid;
    displayedColumns: string[] = ['createdDate', 'createdBy', 'description', 'sportSeason', 'sportType', 'newValue', 'previousValue', 'institutionTerm', 'financialAidType'];
    dataSource = new MatTableDataSource<IAuditTrail>();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    constructor(public auth: AuthService,
        private _audittrailservice: AuditTrailService,
        private _route: ActivatedRoute) {
    }
    ngOnInit() {      
        this._route.queryParams.subscribe(params => {
            this.studentID = params.id;
        });
        this.getAuditTrail();
    }

    ngAfterViewInit(): void {
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
      }
  
    private getAuditTrail() {
        this._audittrailservice.get(this.studentID).subscribe((result: ApiResult<IAuditTrail[]>) => {
            if (result.validationErrors == null) {
                this.dataSource = new MatTableDataSource<IAuditTrail>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        }, error => console.error(error));
    }
}
